import * as yup from 'yup';

import {
	AutosuggestResponse,
	ILocationSuggest,
	Item,
	TLocationSuggestResultType,
	TLocationSuggestType,
} from '@mopla/data-models';
import { germanyCenter, getLocationCategory } from '@mopla/utils';

import { BusinessLayer } from '../../business-logic';

const LOCATION_RESULT_TYPES: ReadonlyArray<TLocationSuggestResultType> = [
	'VIRTUAL',
	'PHYSICAL',
	'place',
	'locality',
	'street',
	'houseNumber',
	'administrativeArea',
	'addressBlock',
	'intersection',
	'postalCodePoint',
	'chainQuery',
	'categoryQuery',
];

const suggestionSchema = yup.object({
	id: yup.string().required(),
	title: yup.string().required(),
	position: yup
		.object({
			lat: yup.number().required(),
			lng: yup.number().required(),
		})
		.required(),
	resultType: yup
		.mixed<TLocationSuggestResultType>()
		.oneOf([...LOCATION_RESULT_TYPES, undefined])
		.optional(),
	address: yup.object().optional(),
});

type TValidatedSuggestion = yup.InferType<typeof suggestionSchema>;

export const getLocations = async (
	query: string,
	businessLayer: BusinessLayer,
	position?: string
): Promise<ILocationSuggest[]> => {
	const result: AutosuggestResponse = await businessLayer.api.get(
		`/api/here/autosuggest?q=${query}&at=${
			position || germanyCenter.toString()
		}`
	);

	return (result.items ?? [])
		.filter((suggestion: Item): suggestion is Item & TValidatedSuggestion =>
			suggestionSchema.isValidSync(suggestion)
		)
		.map((suggestion): ILocationSuggest => {
			const type = getLocationCategory(
				suggestion,
				'address' as TLocationSuggestType
			);

			return {
				id: suggestion.id,
				position: suggestion.position,
				title: suggestion.address?.label ?? suggestion.title,
				type,
				resultType: suggestion.resultType,
				address: suggestion.address,
			};
		});
};
